import React from 'react';
import { useLocation } from 'react-router-dom';
import AffiliatedAd from './AffiliatedAd.tsx';
import { AD_DIMENSIONS, type AdSize } from './adUnits.ts';
import { isSecretProjectPath } from './isSecretProjectPath.ts';
import '../cssComponents/ads.css';

type AdSlotProps = {
  size: AdSize;
  className?: string;
  label?: boolean;
};

const AdSlot: React.FC<AdSlotProps> = ({ size, className = '', label = true }) => {
  const { pathname } = useLocation();

  if (isSecretProjectPath(pathname)) {
    return null;
  }

  const { width, height } = AD_DIMENSIONS[size];

  return (
    <aside
      className={`watchfolio-ad-slot watchfolio-ad-slot--${size} ${className}`.trim()}
      style={{ '--ad-width': `${width}px`, '--ad-height': `${height}px` } as React.CSSProperties}
      aria-label="Publicidade"
    >
      {label && <span className="watchfolio-ad-label">Publicidade</span>}
      <div className="watchfolio-ad-frame">
        <AffiliatedAd size={size} />
      </div>
    </aside>
  );
};

export default AdSlot;
